<template>
    <form method="post" @submit.prevent="submit">
        <div class="col-12 form-group">
            <h1 class="public-header">{{ header }}</h1>
            <div class="errortext" v-if="errorReason">{{ errorReason }}</div>
            <h2 v-if="subheader" class="public-subhead">{{ subheader }}</h2>
            <p class="public-description">{{ description }}</p>
        </div>
        <div class="col-12 form-group">
            <label>{{ isPasswordReset ? "New Password" : "Password" }}</label>
            <input class="form-control input-sm" name="new-password" type="password" v-model="newPassword" @input="debounceVerify(newPassword)" autofocus/>
        </div>
        <div class="col-12 form-group">
            <label>Re-enter Password</label>
            <input class="form-control input-sm" name="confirm-password" type="password" v-model="confirmPassword" @input="confirmPasswordMatch" autofocus/>
            <div style="color: red" v-if="invalidConfirmation">Password confirmation does not match</div>
        </div>
        <div class="col-12">
            <p>
                <label>Password must:</label>
                <ul style="margin-bottom: 0">
                    <li v-for="(requirement, index) in passwordRequirements" :key="index"
                    :style="{ color : requirementNotMet(requirement) ? 'red' : ''}">
                        {{ requirement }}
                    </li>
                </ul>
            </p>
            <p v-if="isPasswordReset">Do you want to <router-link to="/forgot-password">resend the password reset email?</router-link></p>
        </div>
        <div class="col-12 form-group">
            <button class="btn btn-public">{{ buttonText }}</button>
        </div>
    </form>
</template>

<script>
    import Axios from 'axios';
    import { config } from '../config'

    export default {
        props: {
            isPasswordReset: { type: Boolean, default: false },
            uuid: { type: String },
            passcode: { type: String },
            errorReason: { type: String }
        },
        data() {
            return {
                newPassword: null,
                confirmPassword: null,
                passwordRequirements: [],
                remainingRequirements: [],
                debounceVerify: _.debounce(this.verifyPasswordRequirements, 500),
                invalidConfirmation: false,
                confirmPasswordMatch: _.debounce(() => {
                    this.invalidConfirmation = this.newPassword && this.confirmPassword && this.newPassword != this.confirmPassword;
                }, 500)
            }
        },
        computed: {
            buttonText() {
                return this.isPasswordReset ? 'Reset Password' : 'Register'
            },
            header() {
                return this.isPasswordReset ? 'Reset Password' : 'Account Setup';
            },
            subheader() {
                return this.isPasswordReset ? null : 'Password Creation';
            },
            description() {
                return this.isPasswordReset ? 'Please enter your new password.' : 'Please set your password below';
            }
        },
        async created() {
            let status = await Axios.get(`${config.romeApi}/authentication/password/reset/status?userId=${this.uuid}&passcode=${this.passcode}`);
            if(!status.data.passcodeActive) {
                this.$emit('link-expired');
            }
            else {
                this.passwordRequirements = status.data.requirements;
            }
        },
        methods: {
            requirementNotMet(message) {
                return this.remainingRequirements.includes(message);
            },
            async verifyPasswordRequirements(password) {
                if(!password) {
                    this.remainingRequirements = [];
                    return;
                }
                var result = await Axios.get(`${config.romeApi}/authentication/password/reset/validate?userId=${this.uuid}&password=${this.newPassword}`)
                this.remainingRequirements = result.data;
            },
            async submit() {
                if(!this.newPassword || !this.confirmPassword) {
                    toastService.error('Please provide a password and confirm it by re-entering it again.');
                    return false;
                }

                if(this.newPassword != this.confirmPassword) {
                    toastService.error('Passwords do not match. Please re-enter your password.');
                    return false;
                }
                
                this.$emit('submit', { password: this.newPassword, confirmPassword: this.confirmPassword });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/framework/PasswordForm.vue